import { memo } from "react";

import Chip from "@mui/material/Chip";

import {
  FindingSeverity,
  FindingSeverityLabel,
  FindingSeverityColor,
} from "stores/FindingStore";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingSeverityRow = memo(
  function OrganizationFindingSeverityRow({
    severity,
  }: OrganizationFindingSeverityRowProps): JSX.Element {
    return (
      <Abstract label="Severity">
        <Chip
          color={FindingSeverityColor[severity] as any}
          label={FindingSeverityLabel[severity]}
          sx={{ fontWeight: "bold" }}
          size="small"
        />
      </Abstract>
    );
  }
);

export default OrganizationFindingSeverityRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingSeverityRowProps {
  severity: FindingSeverity;
}
